import React, { useEffect, useLayoutEffect, useState } from "react";
import { Grid } from "@mui/material";
import TrayModal from "components/ui/TrayModal";
import SortContext from "context/SortContext";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import SetCard from "components/ui/SetCard";
import { useGlobalContext } from "context/GlobalContext";
import { useSets } from "../api/get-sets";
import { transformSetData } from "utils/transformdata";
import { useInView } from "react-intersection-observer";
import { useRemoveDesings } from "../hooks/useRemoveDesigns";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import { useNavigate, useNavigationType } from "react-router-dom";
import { useFilter } from "context/FilterContext";
import apiClient from "lib/api-client";
import SetSkeleton from "components/ui/Skeleton/SetSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removeFromCart } from "store/cartSlice";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

const SET_LIST_SCROLL_RESTORE_KEY = "setListScrollRestoreY";

const Sets = ({ innerChnages, location }) => {
  const { isEdit, selectedSortValue, sortOptions, search, setSearch } = React.useContext(SortContext);
  const [showTrayModal, setShowTrayModal] = React.useState(false);
  const [removeModal, setRemoveModal] = React.useState(false);
  const [currentSet, setCurrentSet] = useState({});
  const [setsbtnTitles, setSetsBtnTitles] = useState({});
  const {
    setCountCart,
    countCart,
    setFilterChangeCount,
    setDisplayCount,
    dynamicfilterCount,
    setSearchResultCount,
    filterChangeCount,
    setDynamicFilterCount,
    // updateCatalogProductsData,
    // addToCart,
    // removeFromCart,
    // cartData,
    setUpdateCatalogProductsData,
  } = useGlobalContext();
  const selectedSetRef = React.useRef(null);
  const { handleArchiveSet } = useRemoveDesings();
  const [isPresent, setIsPresent] = useState({});
  const navigate = useNavigate();
  const navigationType = useNavigationType();
  const [viewset, setViewset] = React.useState({
    id: "",
  });
  const { filterValues, setFilterCount, backendFilterValues } = useFilter();

  const cartData = useSelector((state) => state.cart.cartData);
  //open the archive modal
  const openArchiveModal = (e, setId) => {
    e.stopPropagation();
    selectedSetRef.current = setId;
    setRemoveModal(true);
  };

  const handleArchive = React.useCallback(() => {
    if (selectedSetRef.current) {
      handleArchiveSet(selectedSetRef.current);
      setRemoveModal(false);
    } else {
      console.error("No set ID selected for archiving");
    }
  }, [handleArchiveSet]);

  const modalBtnInfo = React.useMemo(
    () => [
      {
        btnName: "Archive",
        bgColor: "#E77B7B",
        click: handleArchive,
      },
      {
        btnName: "Keep",
        bgColor: "#50C878",
        click: () => setRemoveModal(false),
      },
    ],
    []
  );

  //fetch the sets data
  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;
  const diamondPieces = filterValues && filterValues["Diamond Pieces"];
  const diamondWeight = filterValues && filterValues["Diamond Weight"];
  const goldGrossWeight = filterValues && filterValues["Gold Gross-Weight"];
  const goldNetWeight = filterValues && filterValues["Gold Net-Weight"];
  const designQuantity = filterValues && filterValues?.piecesCount?.length > 0 ? filterValues?.piecesCount[0] : "";
  const collectionName = filterValues && filterValues?.collectionName?.length > 0 ? filterValues?.collectionName[0] : "";
  const categoriesName = filterValues && filterValues?.categoriesName;

  const isFilterReady = Object.keys(filterValues || {}).length > 0;

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error } = useSets({
    limit: 12,
    sortBy: selectedSortBY,
    order: selectedSortOrder,
    searchTerm: search,
    diamondPieces,
    diamondWeight,
    goldGrossWeight,
    goldNetWeight,
    designQuantity,
    collectionName,
    categoriesName,
    enabled: isFilterReady,
  });

  const { ref, inView } = useInView({
    triggerOnce: false,
    threshold: 0.5,
  });

  const dispatch = useDispatch();

  // useEffect(() => {
  //   setFilterChangeCount(data?.pages[0]?.totalSets);
  //   setDisplayCount(true);
  //   return () => {
  //     setFilterChangeCount(0);
  //     setDisplayCount(false);
  //   };
  // }, [data]);

  useEffect(() => {
    if (search === "") {
      setDynamicFilterCount(true);
    }
    if (dynamicfilterCount) {
      setFilterChangeCount(data?.pages[0]?.totalSets);
      // setFilterChangeDesignCount(data?.pages[0]?.totalStyles);
      setSearchResultCount(data?.pages[0]?.totalSets);
    } else {
      setSearchResultCount(data?.pages[0]?.totalSets);
      setFilterChangeCount(filterChangeCount);
      // setFilterChangeDesignCount(filterChangeDesignCount);
    }
    setDisplayCount(true);
    return () => {
      setSearchResultCount(0);
      setFilterChangeCount(0);
      // setFilterChangeDesignCount(0);
      setDisplayCount(false);
    };
  }, [data]);

  //end fetch code

  const toggleDrawer = (data, set) => {
    setCurrentSet(set?.designs[0]);
    setShowTrayModal(true);
    setViewset({
      id: data,
    });
  };

  const handleAddSetButton = (set) => {
    let getCartData = JSON.parse(sessionStorage.getItem("CartData")) || [];
    let updateCatalogProductsData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];

    setSetsBtnTitles((preTitles) => {
      if (setsbtnTitles[set._id] == "Added") {
        let filterCardData = [];
        if (getCartData && getCartData.length > 0 && updateCatalogProductsData && updateCatalogProductsData.length > 0) {
          // let findInUpdateCatalog = [...updateCatalogProductsData, ...getCartData].filter((item) => set.designs[0].some((curElm) => (curElm.id || curElm._id) === (item.id || item._id)));
          let findInUpdateCatalog = [...getCartData].filter((item) => set.designs[0].some((curElm) => (curElm.id || curElm._id) === (item.id || item._id)));

          filterCardData = [...findInUpdateCatalog].filter((item) => set.designs[0].some((curElm) => (curElm.id || curElm._id) === (item.id || item._id)));
          filterCardData.forEach((product) => {
            // removeFromCart(product);
            dispatch(removeFromCart(product));
          });
        } else {
          filterCardData = getCartData.filter((item) => set.designs[0].some((curElm) => (curElm.id || curElm._id) === (item.id || item._id)));
          filterCardData.forEach((product) => {
            // removeFromCart(product);
            dispatch(removeFromCart(product));
          });
        }
        let filterLength = getCartData.length - filterCardData.length;
        // sessionStorage.setItem("CartData", JSON.stringify(filterCardData));
        // setCountCart((prevCount) => prevCount - filterLength);
        window.dispatchEvent(new Event("cartUpdated"));
        return {
          ...preTitles,
          [set._id]: "Add",
        };
      } else {
        let productsToAdd = [];
        if (updateCatalogProductsData && updateCatalogProductsData.length > 0) {
          // productsToAdd = set.designs[0].filter((product) => ![...updateCatalogProductsData].some((cartItem) => (cartItem.id || cartItem._id) === (product.id || product._id)));
          productsToAdd = set.designs[0].filter((product) => ![...getCartData, ...updateCatalogProductsData].some((cartItem) => (cartItem.id || cartItem._id) === (product.id || product._id)));
          productsToAdd.forEach((product) => {
            // addToCart(product);
            dispatch(
              // addToCart("",product)

              addToCart({
                product: product,
                location: location,
              })

              // {
              //   product: product,
              //   location: location,
              // }
            );
          });
        } else {
          // productsToAdd = set.designs[0].filter((product) => !getCartData.some((cartItem) => (cartItem.id || cartItem._id) === (product.id || product._id)));
          productsToAdd = set.designs[0].filter((product) => !getCartData.some((cartItem) => (cartItem.id || cartItem._id) === (product.id || product._id)));
          productsToAdd.forEach((product) => {
            // addToCart(product);
            dispatch(
              addToCart({
                product: product,
                location: location,
              })

              // {
              //   product: product,
              //   location: location,
              // }
            );
          });
        }
        getCartData = [...getCartData, ...productsToAdd];
        // sessionStorage.setItem("CartData", JSON.stringify(getCartData));
        // setCountCart((prevCount) => prevCount + productsToAdd.length);
        window.dispatchEvent(new Event("cartUpdated"));
        return {
          ...preTitles,
          [set._id]: "Added",
        };
      }
    });
  };

  useEffect(() => {
    if (location?.state?.innerChnages && location?.state?.cataloguUpdate) {
      const updateData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];
      setUpdateCatalogProductsData(updateData);
      // const getCartData = JSON.parse(sessionStorage.getItem("CartData")) || [];
      const alredyPresent = {};
      const newSetsBtnTitles = {};
      if (data?.pages) {
        data.pages.forEach((page) => {
          page?.sets?.forEach((curSet) => {
            const allProductsInCatalog = curSet?.designs[0]?.every((product) => updateData.some((catalogItem) => (catalogItem._id || catalogItem.id) === product._id));

            newSetsBtnTitles[curSet?._id] = allProductsInCatalog ? "Added" : "Add";
            alredyPresent[curSet?._id] = allProductsInCatalog ? true : false;

            if (cartData && cartData.length > 0) {
              const allProductsInCart = curSet?.designs[0]?.every((product) => cartData.some((cartItem) => (cartItem._id || cartItem.id) === product._id));
              newSetsBtnTitles[curSet?._id] = allProductsInCart ? "Added" : "Add";
            }

            if (cartData && cartData.length > 0 && updateData && updateData.length > 0) {
              let newCartData = [...cartData, ...updateData];
              const allProductsInCart = curSet?.designs[0]?.every((product) => newCartData.some((cartItem) => (cartItem._id || cartItem.id) === product._id));
              newSetsBtnTitles[curSet?._id] = allProductsInCart ? "Added" : "Add";
            }
          });
        });

        // Only update state if the values are different
        setSetsBtnTitles((prev) => {
          if (JSON.stringify(prev) !== JSON.stringify(newSetsBtnTitles)) {
            return newSetsBtnTitles;
          }
          return prev;
        });

        setIsPresent((prev) => {
          if (JSON.stringify(prev) !== JSON.stringify(alredyPresent)) {
            return alredyPresent;
          }
          return prev;
        });
      }
    } else {
      const getCartData = JSON.parse(sessionStorage.getItem("CartData")) || [];
      const newSetsBtnTitles = {};
      if (data?.pages) {
        data.pages.forEach((page) => {
          page?.sets?.forEach((curSet) => {
            // const allProductsInCart = curSet?.designs[0]?.every((product) => getCartData.some((cartItem) => (cartItem._id || cartItem.id) === product._id));
            const allProductsInCart = curSet?.designs[0]?.every((product) => cartData.some((cartItem) => cartItem.styleNumber === product.styleNumber));
            //  const allProductsInCatalog = curSet?.designs[0]?.every((product) => updateCatalogProductsData.some((catalogItem) => (catalogItem._id || catalogItem.id) === product._id));

            newSetsBtnTitles[curSet?._id] = allProductsInCart ? "Added" : "Add";
          });
        });

        // Only update state if the values are different
        setSetsBtnTitles((prev) => {
          if (JSON.stringify(prev) !== JSON.stringify(newSetsBtnTitles)) {
            return newSetsBtnTitles;
          }
          return prev;
        });
      }
      // setSetsBtnTitles((prevSetsBtnTitles) => {
      //   const newSetsBtnTitles = { ...prevSetsBtnTitles };
      //   data?.pages?.forEach((page) => {
      //     page?.sets?.forEach((curSet) => {
      //       const allProductsInCart = curSet?.designs[0]?.every((product) => getCartData.some((cartItem) => (cartItem._id || cartItem.id) === product._id));
      //       newSetsBtnTitles[curSet?._id] = allProductsInCart ? "Added" : "Add";
      //     });
      //   });
      //   return newSetsBtnTitles;
      // });
    }
  }, [data, setsbtnTitles, showTrayModal, cartData]);

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  useLayoutEffect(() => {
    if (navigationType === "POP") {
      const raw = sessionStorage.getItem(SET_LIST_SCROLL_RESTORE_KEY);
      if (raw != null && raw !== "") {
        const y = Number.parseInt(raw, 10);
        if (!Number.isNaN(y)) {
          window.scrollTo(0, y);
        }
        sessionStorage.removeItem(SET_LIST_SCROLL_RESTORE_KEY);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [navigationType, location.pathname]);

  useEffect(() => {
    return () => {
      setFilterCount(0);
      setSearch("");
    };
  }, []);

  const flatData = data?.pages?.flatMap((page) => page?.sets) || [];
  if (isLoading) return <SetSkeleton count={12} />;
  if (isError) return <div style={{ color: "red" }}>Error: {error.message}</div>;

  const hasNoResults = search && !flatData?.length;
  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  if (flatData?.length === 0) return <SetSkeleton count={12} />;

  return (
    <>
      <Grid
        container
        className="Grid-padding"
        direction="row"
        justifyContent="flex-start"
        sx={{ flex: "1 1 1", display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "30px", rowGap: "32px" }}
      >
        {data?.pages?.map((page) =>
          page?.sets?.map((set, _ind) => (
            <Grid item className="product" key={set._id}>
              <SetCard
                isBtn={isEdit}
                openDrawer={() => toggleDrawer(set._id, set)}
                parentClick={
                  isEdit === "archive"
                    ? () => {
                      const state = {
                        ...location.state,
                        name: [`SET-${set?.setNumber} - ${set?.numberOfStyles}`],
                        setSearch: search !== "" ? search : "",
                      };
                      let setId = encodeURIComponent(set._id);
                      let setNumberAndCount = encodeURIComponent(`SET-${set?.setNumber} - ${set?.numberOfStyles}`);
                      localStorage.setItem("navigatingToDesignPage", "true");

                      sessionStorage.setItem(SET_LIST_SCROLL_RESTORE_KEY, String(window.scrollY));
                      navigate(`./${setId}?setNumber=${setNumberAndCount}`, { state }); //To handle Visibilty of FilterCount of Sets
                    }
                    : null
                }
                btnTitle={innerChnages ? (setsbtnTitles[set._id] && setsbtnTitles[set._id] == "Added" ? "Added" : "Add") : "Archive"}
                buttonClick={innerChnages ? () => handleAddSetButton(set) : (e) => openArchiveModal(e, set._id)}
                innerChnages={innerChnages}
                data={transformSetData(set)}
                isPresent={innerChnages && location?.state?.cataloguUpdate ? (isPresent[set._id] && isPresent[set._id] == true ? true : false) : false}
              />
            </Grid>
          ))
        )}
      </Grid>

      <RemoveModal open={removeModal} setOpen={setRemoveModal} btnInfo={modalBtnInfo} heading="Do you want to Archive the Set?" />

      <TrayModal cardId={viewset} open={showTrayModal} setOpen={setShowTrayModal} isView={isEdit === "click" ? false : true} innerChnages={innerChnages} currentSet={currentSet} />

      {isFetchingNextPage && <SetSkeleton count={12} />}
      <div ref={ref} style={{ height: "40px", marginTop: "0px" }} />
    </>
  );
};

export default Sets;
